/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthConfigService, AuthToken } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CustomUserAuthenticationTokenService {
  protected http = inject(HttpClient);
  protected authConfigService = inject(AuthConfigService);

  loadTokenUsingCustomFlow(
    idToken: string,
  ): Observable<Partial<AuthToken> & { expires_in?: number }> {
    const url = this.authConfigService.getTokenEndpoint();

    const params = new HttpParams({
      fromObject: { grant_type: 'custom', code: idToken },
    });

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Basic ${btoa('portal_access:secret')}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
    };
    return this.http
      .post<Partial<AuthToken> & { expires_in?: number }>(url, params.toString(), httpOptions)
      .pipe(catchError((error: any) => throwError(error)));
  }
}
